import { render } from "./SidebarMain.vue?vue&type=template&id=97155dda&scoped=true&ts=true"
import script from "./SidebarMain.vue?vue&type=script&lang=ts"
export * from "./SidebarMain.vue?vue&type=script&lang=ts"

import "./SidebarMain.vue?vue&type=style&index=0&id=97155dda&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97155dda"],['__file',"src/layouts/sidebar/SidebarMain.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "97155dda"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('97155dda', __exports__)) {
    api.reload('97155dda', __exports__)
  }
  
  module.hot.accept("./SidebarMain.vue?vue&type=template&id=97155dda&scoped=true&ts=true", () => {
    api.rerender('97155dda', render)
  })

}


export default __exports__